<template>
    <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.4993" cy="4.9974" r="3.33333" stroke="currentColor" stroke-width="1.5"/>
        <ellipse cx="10.4993" cy="14.1693" rx="5.83333" ry="3.33333" stroke="currentColor" stroke-width="1.5"/>
    </svg>
</template>